module.exports = __webpack_public_path__ + "static/media/icon-adventuresome.44788cbf.svg";